/**
 * 谷歌分析
 */
const googleAnalysis = {
  namespaced: true,
  state: () => ({
    enable: false,
    trackId: null,
    ecommerce: false
  }),

  mutations: {
    save(state, { payload }) {
      state.enable = payload.enable
      state.trackId = payload.trackId
      state.ecommerce = payload.ecommerce
    }
  }
}
export default googleAnalysis
